





















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Email from "@/domainObjects/Email";
import AdminService from "@/services/AdminService";
import Subscription, {SubscriptionFlagValue} from "@/domainObjects/Subscription";

@Component({
    components: {},
})
export default class ManageEmailSubscriptions extends Vue {
    @Prop({required: true}) email!: Email;
    @Prop({required: false}) buttonName!: string;

    private emailCopy: Email = new Email();
    private showModal: boolean = false;
    private holdOpenTrue: number = SubscriptionFlagValue.HoldOpen;
    private holdUpdateTrue: number = SubscriptionFlagValue.HoldUpdate;
    private holdCloseTrue: number = SubscriptionFlagValue.HoldClose;
    private wipOpenTrue: number = SubscriptionFlagValue.WipOpen;
    private wipUpdateTrue: number = SubscriptionFlagValue.WipUpdate;
    private wipCloseTrue: number = SubscriptionFlagValue.WipClose;

    get subscriptionCount(): number {
        let count: number = 0;
        for (let value in SubscriptionFlagValue) {
            if (Number(value)) {
                // @ts-ignore
                if ((value | this.email.subscribeFlag) == this.email.subscribeFlag) {
                    count++
                }
            }
        }
        return count;
    }

    openModal():void {
        this.showModal = true;
        this.emailCopy = new Email();
        this.emailCopy.initFromObject(this.email);
    }

    closeModal():void {
        this.showModal = false;
    }

    updateGroup():void{
        this.email = this.emailCopy;
        this.email.subscribeFlag = this.email.subscriptions.createBitFlagFromSubscriptionData();
        let emailJSON = JSON.stringify(this.email);
        AdminService.updateEmail(emailJSON).then((response)=>{
            this.$emit('update:email', this.email);
            this.showModal = false;
        }).catch((error)=>{

        })
    }
}
